"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateNominalProviderFeeAmount = void 0;
const utils_1 = require("../../utils");
/**
 * Calculates the nominal provider fee amount for a transaction.
 * This calculation considers both the default and actual fee structures,
 * ensuring the nominal fee does not exceed the non-recurring fee limit.
 * - It will be added to the amount if the user chooses to cover the fee
 * - It will be used as the maximal amount for the final totalFeeAmount
 *
 * @param {Object} params - Parameters required for the calculation.
 * @param {number} params.transactionAmount - The original transaction amount.
 * @param {PayPalModelFeeStructureCountry} params.defaultFeeStructure - The default fee structure for transactions.
 * @param {ActualPayPalFeeStructure} params.actualFeeStructure - The actual fee structure applied to the transaction.
 * @returns {number} The calculated nominal provider fee amount.
 */
const calculateNominalProviderFeeAmount = ({ transactionAmount, defaultFeeStructure, actualFeeStructure, }) => {
    // Calculate the fee based on the actual fee structure (e.g in case of recurring payments).
    const actualFee = transactionAmount * (actualFeeStructure.relativeFee / 100) + actualFeeStructure.fixedFee;
    // Calculate the fee based on the default fee structure (e.g in case of one-time payments).
    const defaultFee = transactionAmount * (defaultFeeStructure.relativeFee / 100) + defaultFeeStructure.fixedFee;
    // Determine the lesser of the two fees to ensure we do not exceed the expected fee cap. (nominal fee) <= (non-recurring fee)
    const nominalFee = Math.min(actualFee, defaultFee);
    return (0, utils_1.roundNumber)(nominalFee);
};
exports.calculateNominalProviderFeeAmount = calculateNominalProviderFeeAmount;
//# sourceMappingURL=calculateNominalProviderFeeAmount.js.map